export enum Launch_Thunderkick {
  "pt-br" = "pt-br",
  "es-LA" = "es-LA",
  hu = "hu",
}
